export default __webpack_public_path__ + "static/media/numedy.773b661a.png";